import { gql } from "apollo-angular";
import FundType from "../../../interfaces/fund-type";
import ID from "../../../types/id";
import Fund from "../../../interfaces/fund";

type GetFundInfoResult = {
  fundTypes: FundType[];
}
type GetFundInfoVariables = {};
export const GET_FUND_INFO = gql<GetFundInfoResult,GetFundInfoVariables>`
  query getFundInfo{
    fundTypes{
      id
      name
    }
  }
`;
export interface CreateFundInput {
  name:string;
  fund_type_id: ID;
  managing_member_name: string | null;
  legal_name: string;
  invested_equity: number | null;
  close_date: string | null;
}
type CreateFundResult = {
  createFund:Fund
}
type CreateFundVariables = {
  input: CreateFundInput;
}
export const CREATE_FUND = gql<CreateFundResult,CreateFundVariables>`
  mutation createFund($input: CreateFundInput) {
    createFund(input: $input) {
        id
    }
  }
`;
